import { getUserId } from '../_utils/storage_handler';
import { sendSellerFetch, GET_OPTIONS, POST_OPTIONS } from './base.service';

const BASE_PATH = '/orders-list-view';

export const findAllClientsPaged = async (page, count) => {
    return await sendSellerFetch(`${BASE_PATH}/clients/${page}/${count}`, GET_OPTIONS);
}

export const findAllClientsByNamePaged = async (name, page, count) => {
    return await sendSellerFetch(`${BASE_PATH}/clients/name/${name}/${page}/${count}`, GET_OPTIONS);
}

export const findAllOrderListLiveGroupByClient = async (client) => {
    return await sendSellerFetch(`${BASE_PATH}/live-group/${client}`, GET_OPTIONS);
}

export const findOrderGroupById = async (uuid) => {
    return await sendSellerFetch(`${BASE_PATH}/group/order-id/${uuid}`, GET_OPTIONS);
}

export const findAllOrderListGroupByClient = async (client) => {
    return await sendSellerFetch(`${BASE_PATH}/all-group/${client}`, GET_OPTIONS);
}

export const findAllOrderListGroupDeparturesByClient = async (client) => {
    return await sendSellerFetch(`${BASE_PATH}/all-group-departures/${client}`, GET_OPTIONS);
}

export const findAllOrderListGroupDeparturesByClientFilter = async (client, filter) => {
    return await sendSellerFetch(`${BASE_PATH}/all-group-departures/filter/${client}/${filter}`, GET_OPTIONS);
}


export const findAllOrderDetailByOrderAndRefAndColor = async (order, ref, color) => {
    return await sendSellerFetch(`${BASE_PATH}/order-detail/order/${order}/${ref}/${color}`, GET_OPTIONS);
}

export const pdfViewListByOrder = async (order) => {
    return await sendSellerFetch(`${BASE_PATH}/pdf-list/order/${order}`, GET_OPTIONS);
}

export const pdfViewListLiveByClient = async (client) => {
    return await sendSellerFetch(`${BASE_PATH}/pdf-list-live/client/${client}`, GET_OPTIONS);
}

export const pdfViewListByClient = async (client) => {
    return await sendSellerFetch(`${BASE_PATH}/pdf-list/client/${client}`, GET_OPTIONS);
}

export const excelViewListLiveByClient = async (client) => {
    return await sendSellerFetch(`${BASE_PATH}/excel-list-live/client/${client}`, GET_OPTIONS);
}

export const excelViewListByClient = async (client) => {
    return await sendSellerFetch(`${BASE_PATH}/excel-list/client/${client}`, GET_OPTIONS);
}

export const pdfDepartureListByClientDate = async (client, date) => {
    return await sendSellerFetch(`${BASE_PATH}/pdf-list-departure/client/date/${client}/${date}`, GET_OPTIONS);
}

export const viewListGenerailViewFilter = async (body) => {
    return await sendSellerFetch(`${BASE_PATH}/general-view-filter`, POST_OPTIONS, body);
}

export const viewListGenerailViewFilterByOptions = async (body) => {
    return await sendSellerFetch(`${BASE_PATH}/general-view-filter-options`, POST_OPTIONS, body);
}

export const viewListGenerailViewFilterByOptionsNotDispatched = async (body) => {
    return await sendSellerFetch(`${BASE_PATH}/general-view-filter-options-not-dispatched`, POST_OPTIONS, body);
}

export const viewListGenerailSellerViewFilter = async (body) => {
    return await sendSellerFetch(`${BASE_PATH}/general-view-seller-filter/${getUserId()}`, POST_OPTIONS, body);
}

export const viewListGenerailViewlSelleFilterByOptions = async (body) => {
    return await sendSellerFetch(`${BASE_PATH}/general-view-seller-filter-options/${getUserId()}`, POST_OPTIONS, body);
}

export const viewListGenerailViewlSelleFilterByOptionsNotDispatched = async (body) => {
    return await sendSellerFetch(`${BASE_PATH}/general-view-seller-filter-options-not-dispatched/${getUserId()}`, POST_OPTIONS, body);
}